/**
 * Flow display name helpers (Voluum: country prefix + suffix).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { VoluumFlowUpdate } from '@trafficpulse/shared';

export function regionDisplayName(code: string): string {
  try {
    return new Intl.DisplayNames('en', { type: 'region' }).of(code) ?? code;
  } catch {
    return code;
  }
}

export function countryEntry(
  c: { code: string } & Record<string, unknown>,
): { code: string; display: string } {
  const name = c.name;
  const display =
    typeof name === 'string' && name.length > 0 ? name : regionDisplayName(c.code);
  return { code: c.code, display };
}

export function primaryCountry(
  draft: VoluumFlowUpdate,
): { code: string; display: string } | undefined {
  const first = draft.countries?.[0];
  if (!first?.code) return undefined;
  return countryEntry(first as { code: string } & Record<string, unknown>);
}

export function parseBaseName(
  fullName: string,
  countryDisplay: string | undefined,
): string {
  if (!countryDisplay) return fullName;
  const prefix = `${countryDisplay} - `;
  return fullName.startsWith(prefix) ? fullName.slice(prefix.length) : fullName;
}

export function composeName(
  countryDisplay: string | undefined,
  base: string,
): string {
  if (!countryDisplay) return base;
  return `${countryDisplay} - ${base}`;
}

export function workspaceLabel(ws: VoluumFlowUpdate['workspace']): string {
  if (!ws?.id) return '—';
  const n = (ws as { name?: unknown }).name;
  if (typeof n === 'string' && n.length > 0) return n;
  return ws.id;
}
